import $ from "jquery";

class CustomPointer {
    constructor() {
        this.init();
    }

    init() {
        this.dom();
        this.setup();
    }

    dom() {
        this.$body = $('body');
        this.$pointer = $('#pointer');
    }

    setup() {
        // append cursor element
        if (this.$pointer.length < 1) {
            this.$pointer = $('<div>').attr('id', 'pointer');
            this.$pointer.appendTo(this.$body);
            console.log('CustomPointer initialized');
        }

        console.log('CustomPointer initialized');
    }
}

export default CustomPointer;
